export default "__VITE_ASSET__D$3og8Yp__"